var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.5 16.4609L4.85938 9.39062C4.9005 9.26561 4.98004 9.15677 5.08666 9.07961C5.19327 9.00246 5.32152 8.96093 5.45313 8.96094H16.25V7.08594C16.25 6.92018 16.1842 6.76121 16.0669 6.644C15.9497 6.52679 15.7908 6.46094 15.625 6.46094H10.2109C10.0758 6.46038 9.94438 6.41658 9.83594 6.33594L7.66406 4.71094C7.55562 4.6303 7.4242 4.58649 7.28906 4.58594H3.125C2.95924 4.58594 2.80027 4.65179 2.68306 4.769C2.56585 4.88621 2.5 5.04518 2.5 5.21094V16.4609Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.4609V5.21094C2.5 5.04518 2.56585 4.88621 2.68306 4.769C2.80027 4.65179 2.95924 4.58594 3.125 4.58594H7.28906C7.4242 4.58649 7.55562 4.6303 7.66406 4.71094L9.83594 6.33594C9.94438 6.41658 10.0758 6.46038 10.2109 6.46094H15.625C15.7908 6.46094 15.9497 6.52679 16.0669 6.644C16.1842 6.76121 16.25 6.92018 16.25 7.08594V8.96094",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.4609L4.85938 9.39062C4.9005 9.26561 4.98004 9.15677 5.08666 9.07961C5.19327 9.00246 5.32152 8.96093 5.45313 8.96094H17.8828C17.9816 8.96093 18.0791 8.98436 18.1671 9.0293C18.2551 9.07424 18.3312 9.13942 18.3892 9.21948C18.4471 9.29954 18.4852 9.3922 18.5004 9.48985C18.5156 9.5875 18.5074 9.68737 18.4766 9.78125L16.25 16.4609H2.5Z",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFolderOpen);
export default __webpack_public_path__ + "static/media/file-folder-open.bbf25ffd8db54d4cea58c896cea50b44.svg";
export { ForwardRef as ReactComponent };